import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const ViewDocument = ({ pdfBytes }: any) => (
  <Document
    file={URL.createObjectURL(
      new Blob([pdfBytes], { type: 'application/pdf' }),
    )}
  >
    <Page
      pageNumber={1}
      renderAnnotationLayer={false}
      renderTextLayer={false}
    />
  </Document>
);

export default ViewDocument;
